//Note that adding entries here will require more bits to be assigned for storing this in the
//pipeline hash (in Pipelines.js)
export const DepthBiasesPolygon = [
	{ depthBias: 0, depthBiasSlopeScale: 0 }, //polygon edges (3d line)
	{ depthBias: -1, depthBiasSlopeScale: -0.5 }, //heatmap overlay
	{ depthBias: -2, depthBiasSlopeScale: -1 }, //global default for all polygons in main pass
	{ depthBias: 1, depthBiasSlopeScale: 1 }, //room highilight (back walls of room)
];

//Note that adding entries here will require more bits to be assigned for storing this in the
//pipeline hash (in Pipelines.js)
export const DepthBiasesLine = [
	{ depthBias: 0, depthBiasSlopeScale: 0 },
	{ depthBias: 1, depthBiasSlopeScale: 1 }, //section outline
	{ depthBias: 10, depthBiasSlopeScale: 10 }, //floor/room outline when visible edges are desired
	{ depthBias: -10, depthBiasSlopeScale: -10 }, //floor/room outline when hidden edges are desired
];

export function deriveDepthBias(material) {

	const cur = material.__gpuDepthBiasIndex;

	if (cur !== undefined) {
		return cur;
	}

	if (!material.polygonOffset) {
		return material.__gpuDepthBiasIndex = 0;
	}

	let idx = 0;

	const whichList = material.is2d ? DepthBiasesLine : DepthBiasesPolygon;
	for (let i=1; i<whichList.length; i++) {
		if (-whichList[i].depthBias === material.polygonOffsetUnits) {
			idx = i;
			break;
		}
	}

	if (idx === 0) {
		console.warn("could not find depth bias entry for material, polygon offset was:", material.polygonOffsetUnits);
	}

	return material.__gpuDepthBiasIndex = idx;
}
